import React, { useEffect, useState } from 'react'
import { Polo } from '../api/auto-types';
import { get_polo } from '../api';
import { useParams } from 'react-router-dom';


const pageMatch = useParams<{ pk: string }>;


const ListaPoli = () => {
  const [poli, setPoli] = useState<Polo[]>([])

  const params = pageMatch()
  const pk = parseInt(params.pk || "");


  useEffect(() => {
    get_polo({ evento: pk }).then(setPoli)
  }, [pk])


  return (
    <div className="container">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h1 className="page-header mb-0">Lista dei poli</h1>
      </div>

      <div className="my-4">
        <div className="row">
          {poli.length == 0 && (
            <div className="col-12">
              <div className="alert alert-light border mb-0" role="alert">
                <span className="text-muted">Non ci sono poli per questo evento</span>
              </div>
            </div>
          )}

          {poli.map((polo) => (
            <div className="col-md-4 mb-4" key={polo.id}>
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body d-flex flex-column">
                  {/* Header */}
                  <div className="mb-2">
                    <h5 className="card-title mb-1">{polo.nome_breve}</h5>
                    {polo.indirizzo && (
                      <div className="small text-muted">
                        {polo.indirizzo.citta}, {polo.indirizzo.nome}
                      </div>
                    )}
                  </div>

                  {/* Description */}
                  <div className="mb-3">
                    <p className="card-text text-muted mb-0">{polo.descrizione}</p>
                  </div>

                  {/* Responsabili */}
                  {polo.responsabili.length > 0 && (
                    <div className="mb-3">
                      <div className="small text-uppercase text-muted font-weight-bold mb-2">
                        Responsabili
                      </div>
                      <div className="d-flex flex-wrap">
                        {polo.responsabili.map((resp) => (
                          <span
                            key={resp.id}
                            className="badge badge-light border text-body mr-2 mb-2 p-2"
                            style={{ fontWeight: 500 }}
                          >
                            <span className="d-block">
                              {resp.user.first_name} {resp.user.last_name}
                            </span>
                            <span className="d-block text-muted" style={{ fontWeight: 400 }}>
                              {resp.user.email}
                            </span>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {polo.inseritori.length > 0 && (
                    <div className="mb-3">
                      <div className="small text-uppercase text-muted font-weight-bold mb-2">
                        Inseritori (oltre ai responsabili)
                      </div>
                      <div className="d-flex flex-wrap">
                        {polo.inseritori.map((resp) => (
                          <span
                            key={resp.id}
                            className="badge badge-light border text-body mr-2 mb-2 p-2"
                            style={{ fontWeight: 500 }}
                          >
                            <span className="d-block">
                              {resp.user.first_name} {resp.user.last_name}
                            </span>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}


                  {/* Footer / capacity */}
                  <div className="mt-auto pt-2 border-top">
                    <div className="d-flex align-items-center justify-content-between">
                      <span className="small text-muted">Capacità massima squadre</span>
                      <span className="badge badge-primary">
                        {polo.capacita_massima_squadre}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}


export default ListaPoli;
